import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  observation: yup.string().max(500, 'Máximo 500 caracteres')
})
